import { render, staticRenderFns } from "./SupportPage.vue?vue&type=template&id=7d64df16&scoped=true"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"
import style0 from "./SupportPage.vue?vue&type=style&index=0&id=7d64df16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d64df16",
  null
  
)

export default component.exports